import React from 'react'
import {
  Accordion as SemanticAccordion,
  AccordionProps as SemanticAccordionProps,
  AccordionTitleProps,
  AccordionContentProps,
} from 'semantic-ui-react'
import classnames from 'classnames/bind'
import styles from './styles.scss'

const cx = classnames.bind(styles)

export interface AdcAccordionProps extends SemanticAccordionProps {
  /** Element ID for test automation selectors (data-elm-id). */
  elmId?: string
}

type AdcAccordionComponent = React.FC<AdcAccordionProps> & {
  Accordion: typeof SemanticAccordion.Accordion
  Title: React.ComponentClass<AccordionTitleProps>
  Content: React.FC<AccordionContentProps>
}

const Accordion: AdcAccordionComponent = ({
  className,
  elmId = 'accordion',
  ...rest
}) => (
  <SemanticAccordion
    aria-label='Accordion'
    data-elm-id={elmId}
    className={cx('accordion', className)}
    {...rest}
  />
)

Accordion.Accordion = SemanticAccordion.Accordion
Accordion.Title = SemanticAccordion.Title
Accordion.Content = SemanticAccordion.Content

export default Accordion
